import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL ;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('app_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Grid Bot Control
export const startBot = (userId, symbol) => {
  return api.post('/grid/bot/start', { userId, symbol });
};

export const stopBot = (userId, symbol, reason = 'Manual stop') => {
  return api.post('/grid/bot/stop', { userId, symbol, reason });
};

export const getBotStatus = (userId, symbol) => {
  return api.get(`/grid/bot/status/${userId}/${symbol}`);
};

export const getActiveBots = () => {
  return api.get('/grid/bot/active');
};

// Grid State
export const getGridState = (userId, symbol) => {
  return api.get(`/grid/state/${userId}/${symbol}`);
};

export const getGridOrders = (userId, symbol, status = null) => {
  const url = `/grid/state/${userId}/${symbol}/orders${status ? `?status=${status}` : ''}`;
  return api.get(url);
};

export const getGridTrades = (userId, symbol, limit = 100, skip = 0) => {
  return api.get(`/grid/state/${userId}/${symbol}/trades?limit=${limit}&skip=${skip}`);
};

export const getGridStats = (userId, symbol) => {
  return api.get(`/grid/state/${userId}/${symbol}/stats`);
};

// Sync Orders (Force backend update from Binance)
export const syncOrders = (symbol) => {
  return api.get(`/grid/bot/sync-orders/${symbol}`);
};

// Grid Configuration
export const getGridConfig = (userId, symbol) => {
  return api.get(`/grid/config/${userId}/${symbol}`);
};

export const getAllConfigs = (userId) => {
  return api.get(`/grid/config/${userId}`);
};

export const createGridConfig = (configData) => {
  return api.post('/grid/config', configData);
};

export const updateGridConfig = (userId, symbol, updates) => {
  return api.put(`/grid/config/${userId}/${symbol}`, updates);
};

// Admin: Global Bot Control
export const getGlobalStatus = () => {
  return api.get('/grid/bot/admin/global-status')
    .then(response => response.data);
};

export const stopAllBots = (data) => {
  return api.post('/grid/bot/admin/stop-all', data)
    .then(response => response.data);
};

export const startAllBots = (data) => {
  return api.post('/grid/bot/admin/start-all', data)
    .then(response => response.data);
};

export const getGlobalHistory = (params) => {
  return api.get('/grid/bot/admin/history', { params })
    .then(response => response.data);
};

// Admin: User Orders Control
export const cancelUserOrders = (data) => {
  return api.post('/grid/bot/admin/cancel-orders', data)
    .then(response => response.data);
};

// Users
export const getAllUsers = () => {
  return api.get('/users')
    .then(response => response.data);
};

// Health check
export const checkHealth = () => {
  return api.get('/health');
};

export const getBotTrades = (symbol, targetUserId = null) => {
  const query = targetUserId ? `?targetUserId=${targetUserId}` : '';
  
  return api.get(`/grid/bot/trades/${symbol}${query}`)
    .then(response => response.data)
    .catch(error => {
      console.error('Error fetching bot trades:', error);
      return { success: false, data: [] };
    });
};

export const getAccountHistory = (params) => {
  return api.get('/grid/bot/history/account', { params })
    .then(response => response.data)
    .catch(error => {
      console.error('Error fetching account history:', error);
      return { success: false, data: [], pagination: {} };
    });
};

export default {
  startBot,
  stopBot,
  getBotStatus,
  getActiveBots,
  syncOrders,
  getGridState,
  getGridOrders,
  getGridTrades,
  getGridStats,
  getGridConfig,
  getAllConfigs,
  createGridConfig,
  updateGridConfig,
  //Trades
  getBotTrades,
  getAccountHistory,
  // Admin functions
  getGlobalStatus,
  stopAllBots,
  startAllBots,
  getGlobalHistory,
  cancelUserOrders,
  getAllUsers,
  // Health
  checkHealth
};